import axios from "../index";

const getRegions = () => {
  return axios.get('mn-regions');
}

export default { getRegions }